import { Box } from '@mui/material'
import { useAuth } from '../../../context/AuthContext'
import { useLocation } from 'react-router-dom'
import { useEffect, useMemo, useState } from 'react'
import { editObject, getObject, addObject } from '../../../api/apiClientCrud'
import useNavigate from '../../hooks/useNavigate'
import Form from '../../form/Form'
import { useOutletContext } from 'react-router-dom'
import Toolbar from '../../toolbar/Toolbar'
import { getPriceBookFields } from './PriceBookFields'
import useSaveEntity from '../../hooks/useSaveEntity'
import { useFetchEntities } from '../../hooks/useFetchEntities'

const ROUTES = {
  EDIT: '/priceBooks/edit',
  VIEW: '/priceBooks/view',
  ADD: '/priceBooks/add'
}

const buildPayload = ({ data, user, mode }) => {
  const isEdit = mode === 'edit'

  return {
    ...data,
    ...(isEdit
      ? { lastModBy: user.email }
      : {
          company_id: user.company_id,
          createdBy: user.email
        })
  }
}

const PriceBook = () => {
  const location = useLocation()
  const { user } = useAuth()
  const userRight = useOutletContext()
  const [priceBook, setPriceBook] = useState({})
  const [isSubmit, setIsSubmit] = useState(false)
  const history = useNavigate()

  const path = location.pathname
  const priceBookId = location.state?.id

  const mode = useMemo(() => {
    if (path === ROUTES.EDIT) return 'edit'
    if (path === ROUTES.VIEW) return 'view'
    if (path === ROUTES.ADD) return 'add'
    return null
  }, [path])

  const priceBookQuery =
    mode === 'edit' || mode === 'view' ? { key: 'priceBook', fn: getObject, args: ['priceBooks', priceBookId] } : null
  const queries = [priceBookQuery].filter(Boolean)

  const { data: fetched, loading: loadingEntities } = useFetchEntities(queries)
  const { saveEntity, loading } = useSaveEntity({
    entityName: 'priceBooks',
    mode,
    id: priceBookId,
    user,
    addFn: addObject,
    editFn: editObject,
    updateCounter: false,
    onSuccessRedirect: (id) => history(location.state?.history || ROUTES.VIEW, { state: { id } }),
    onSuccess: () => setIsSubmit(false),
    onError: () => setIsSubmit(false),
    buildPayload
  })

  const toolbar = {
    accessRight: userRight,
    title: () => {
      if (location.pathname.includes('/add')) return 'Nouveau Tarif'

      const hasName = priceBook?.description
      if (hasName) {
        return `Tarif ${priceBook?.description ?? ''}`
      }
      return 'Tarif'
    },
    objectType: 'priceBooks',
    actions: { edit: true, back: true, audits: true, list: true }
  }

  const options = {
    fields: getPriceBookFields(),
    data: priceBook,
    location: location
  }

  useEffect(() => {
    if (!loadingEntities) {
      if (fetched.priceBook) setPriceBook(fetched.priceBook)
    }
  }, [fetched, loadingEntities])

  useEffect(() => {
    if (isSubmit) {
      saveEntity({ data: priceBook })
    }
  }, [isSubmit])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 65px)',
        overflowY: 'auto',
        flexBasis: 'auto',
        flexGrow: 1,
        flexShrink: 1
      }}
    >
      <Toolbar options={toolbar} object={priceBook} />

      <Form
        mode={mode}
        options={options}
        setDataParent={setPriceBook}
        setIsSubmitParent={setIsSubmit}
        loading={loading}
      />
    </Box>
  )
}

export default PriceBook
